import { get } from "lodash"

export const getSelectedView = (_, props) => get(props, "params.selectedView", "summary")
